
  import createMeisterIcons from '../src/createMeisterIcons';

  const CardAlt = createMeisterIcons("card-alt", [["path",{"fill":"currentColor","d":"M3.838 8.25A3.266 3.266 0 0 1 7 5.75h10a3.266 3.266 0 0 1 3.162 2.5zm-.088 1.5V15c0 1.798 1.376 3.25 3.25 3.25h10A3.26 3.26 0 0 0 20.25 15V9.75zM7 4.25A4.76 4.76 0 0 0 2.25 9v6c0 2.602 2.024 4.75 4.75 4.75h10A4.76 4.76 0 0 0 21.75 15V9A4.76 4.76 0 0 0 17 4.25z","key":"fb55d613184884810efae8952c3e514146c1f397","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default CardAlt
  